import React from "react";
import { Tooltip } from "antd";
import { ColumnsType } from "antd/lib/table";
import { Pencil } from "assets/icons";
import useTranslation from "utils/hooks/useTranslation";
import * as S from "./styled/index.styled";

interface ICollum {
  title: string;
  dataIndex: string;
  sorter: any;
  filterMultiple: boolean;
  render: (...args) => JSX.Element | string;
  width: string;
  key: string;
}

const ColumnsTable = ({ handleClick, isAdmin }) => {
  const STRUCTURE = useTranslation({ id: "structure" });
  const NAME = useTranslation({ id: "name" });
  const CODE = useTranslation({ id: "code" });
  const ACTION = useTranslation({ id: "action" });
  const EDIT_UNIT = useTranslation({ id: "edit_unit" });
  const ACTIVE = useTranslation({ id: "active" });
  const INACTIVE = useTranslation({ id: "inactive" });
  const collums: Array<ICollum> = [
    {
      title: STRUCTURE,
      dataIndex: "structure",
      sorter: (a: any, b: any) => {
        a = a.structure || "";
        b = b.structure || "";
        return a.localeCompare(b);
      },
      filterMultiple: false,
      render: (structure: ColumnsType<any>) => `${structure === null || "" ? "-" : structure}`,
      width: "20%",
      key: "structure",
    },
    {
      title: NAME,
      dataIndex: "description",
      sorter: (a: any, b: any) => a.description.localeCompare(b.description),
      filterMultiple: false,
      render: (description: ColumnsType<any>) => `${description}`,
      width: "37%",
      key: "description",
    },
    {
      title: CODE,
      dataIndex: "code",
      sorter: (a: any, b: any) => {
        a = a.code || "";
        b = b.code || "";
        return a.localeCompare(b);
      },
      filterMultiple: false,
      render: (code: ColumnsType<any>) => `${code === null || "" ? "-" : code}`,
      width: "20%",
      key: "code",
    },
    {
      title: "Status",
      dataIndex: "active",
      sorter: (a: any, b: any) => a.active - b.active,
      filterMultiple: false,
      render: (active: ColumnsType<any>) => `${active ? ACTIVE : INACTIVE}`,
      width: "20%",
      key: "active",
    },
  ];

  const actionCollum = {
    title: ACTION,
    dataIndex: "action",
    sorter: false,
    filterMultiple: false,
    key: "actions",
    width: "3%",
    render: (_, record) => (
      <S.ActionContainer>
        <button onClick={() => handleClick(record)} data-testid="editItemTable">
          <Tooltip placement="top" title={EDIT_UNIT}>
            <Pencil className="pencilEdit" data-testid="edit-location-icon" />
          </Tooltip>
        </button>
      </S.ActionContainer>
    ),
  };

  if (isAdmin) {
    collums.push(actionCollum);
  }

  return collums;
};

export default ColumnsTable;
